<template>
  <v-app dark>
    <DefaultNavbar :show-login-and-call-us="showLoginAndCallUs" />
    <v-main>
      <main>
        <slot />
      </main>
    </v-main>
    <Footer />
  </v-app>
</template>

<script lang="ts" setup>
import Footer from "@/components/Footer.vue";
import DefaultNavbar from "./default/DefaultNavbar.vue";

defineProps({
  showLoginAndCallUs: {
    type: Boolean,
    default: () => false
  }
});
</script>
